<div class="device-modal-container flex flex-col h-full bg-white dark:bg-gray-800">

  <!-- Header fijo -->
  <div class="p-6 border-b border-gray-200 dark:border-gray-700 flex-shrink-0">
    <h2 class="text-lg font-bold text-gray-900 dark:text-gray-100">Asignar o desasignar dispositivo</h2>

    <!-- Buscador -->
    <div class="mt-4">
      <div class="relative">
        <input type="text" placeholder="Buscar dispositivo..." [(ngModel)]="searchTerm" (input)="filterDevices()"
          class="w-full px-4 py-2 pl-10 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent">
        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
          </svg>
        </div>
      </div>
    </div>
  </div>

  <!-- Área de contenido con scroll y altura fija -->
  <div class="flex-1 min-h-0 overflow-hidden">
    @if (filteredDevices?.length > 0) {
    <div class="h-full overflow-y-auto">
      <ul class="divide-y divide-gray-200 dark:divide-gray-700">
        @for (device of filteredDevices; track device.id) {
        <li class="flex items-center justify-between px-6 py-4 transition group hover:bg-gray-50 dark:hover:bg-gray-700"
          [class.bg-blue-50]="device.id === data.currentDeviceId"
          [class.dark:bg-blue-900]="device.id === data.currentDeviceId">
          <div class="flex items-center gap-3 flex-1 min-w-0">
            <div class="flex-1 min-w-0">
              <p class="font-semibold text-gray-900 dark:text-gray-100 truncate">{{ getDeviceLabel(device) }}</p>
              @if (device.type_device?.name) {
              <p class="text-sm text-gray-500 dark:text-gray-400 truncate">{{ device.type_device.name }}</p>
              }
            </div>
            <!-- Indicador de estado de conexión -->
            <div class="w-3 h-3 rounded-full border border-white shadow-sm flex-shrink-0"
              [class.bg-green-500]="getDeviceConnectionStatus(device) === 'connected'"
              [class.bg-red-500]="getDeviceConnectionStatus(device) === 'disconnected'"
              [title]="getDeviceConnectionStatus(device) === 'connected' ? 'Conectado' : 'Desconectado'">
            </div>
          </div>
          <div class="flex items-center gap-2 ml-4 flex-shrink-0">
            <button mat-stroked-button color="primary" class="!text-xs !px-3 !py-1 !min-w-0"
              (click)="onFinderClick(device.id)" draggable="false">
              Finder
            </button>
            <div class="flex flex-col items-end">
              <button mat-flat-button color="accent" class="!text-xs !px-3 !py-1 !min-w-0" (click)="assign(device.id)"
                [disabled]="!isDeviceValid(device)" draggable="false">
                Asignar
              </button>
              @if (!isDeviceValid(device)) {
              <span class="text-[10px] text-red-500 font-medium mt-1">{{ getDeviceValidationMessage(device) }}</span>
              }
            </div>
          </div>
        </li>
        }
      </ul>
    </div>
    } @else {
    <div class="flex items-center justify-center h-full p-6">
      <div class="text-center text-gray-500 dark:text-gray-400">
        @if (searchTerm) {
        <p>No se encontraron dispositivos que coincidan con "{{ searchTerm }}"</p>
        } @else {
        <p>No hay dispositivos disponibles para asignar.</p>
        }
      </div>
    </div>
    }
  </div>

  <!-- Footer fijo -->
  <div class="p-6 border-t border-gray-200 dark:border-gray-700 flex-shrink-0">
    <div class="flex justify-between gap-4">
      @if (data.currentDeviceId) {
      <button mat-flat-button color="warn" class="!rounded-lg !px-6 !py-2 !font-semibold" (click)="unassign()"
        draggable="false">
        Desasignar
      </button>
      } @else {
      <div></div>
      }
      <button mat-stroked-button class="!rounded-lg !px-6 !py-2 !font-semibold !border-gray-300 dark:!border-gray-600"
        (click)="close()" draggable="false">
        Cerrar
      </button>
    </div>
  </div>

</div>